export const FILTER_TYPES = {
  RESET: "reset",
  BASE: "base",
  AND: "and",
  OR: "or",
  RANGE: "range"
};
